export enum LeaveSourceType {
    CENTAURUS = 'Centaurus',
    COOK_APP = 'Partner'
}